/*
*
* voto se deve essere visibile il tessuto
*
*/

function textileHide(obj){
   // obj.slideUp(500);
    //obj.fadeOut(1000);

    obj.hide( 'size', null, 400);
}

function textileShow(obj){
   //obj.fadeIn(1000);
    obj.slideDown(500);
}

function textileIsHidden(t,filters){

    // filtri per application
    var hidden = 0;

    if( (filters.underwear ===false) && ( filters.swimwear === false ) && ( filters.sportswear === false) && ( filters.readytowear === false ) ){
        /*hidden = 0;*/
    }else{

        if( filters.underwear === true ){
            if( jQuery(t).data('underwear') === false ){
               hidden = 1;
            }
       }

        if( filters.swimwear === true ){
           if( jQuery(t).data('swimwear') === false){
                hidden = 1;
            }
        }

        if( filters.sportswear === true){
            if( jQuery(t).data('sportswear') === false ){
                hidden = 1;
            }
        }

        if( filters.readytowear === true ){
             if( jQuery(t).data('readytowear') === false ){
                hidden = 1;
            }
        }
    }



    //filtro per peso

    if ( ( jQuery(t).data('weight') < filters.weightLow ) || ( jQuery(t).data('weight') > filters.weightHigh )) {
        hidden = 1;
    }

    //filtro per nome


    if ( filters.textileName !== ''  &&  (  jQuery(t).data('post-id').toString() !== filters.textileName)   ){
        hidden = 1;
    }



    // filtro per applications

     /*if( 
      ( filters.extra_comfort ===false          ) && 
      ( filters.body_moisture_system === false          ) && 
      ( filters.quick_drying === false        ) && 
      ( filters.sun_block === false       ) 
      ){

        console.log("aaa");
      
      }else{

       
      }*/

/*
      if( filters.extra_comfort === true ){
        if( jQuery(t).data('extra-comfort') === false ){
          hidden = 1;
        }
      }

      if( filters.body_moisture_system === true ){
        if( jQuery(t).data('body-moisture-system') === false ){
          hidden = 1;
        }
      }

       if( filters.quick_drying === true ){
        if( jQuery(t).data('quick-drying') === false ){
          hidden = 1;
        }
      }

      if( filters.sun_block === true ){
        if( jQuery(t).data('sun-block') === false ){
          hidden = 1;
        }
      }

      if( filters.estra_fine === true ){
        if( jQuery(t).data('extra-fine') === false ){
          hidden = 1;
        }
      }

      if( filters.chlorine_resistance === true ){
        if( jQuery(t).data('chlorine-resistance') === false ){
          hidden = 1;
        }
      }
      if( filters.no_pilling === true ){
        if( jQuery(t).data('no-pilling') === false ){
          hidden = 1;
        }
      }
      if( filters.easy_care === true ){
        if( jQuery(t).data('easy-care') === false ){
          hidden = 1;
        }
      }
      if( filters.wrinkle_free === true ){
        if( jQuery(t).data('wrinkle-free') === false ){
          hidden = 1;
        }
      }
*/

    if ( hidden === 1){ return true;} 
    
return false;
}




/*
*
* AGGIORNO GLI ELEMENTI 
*
*/


function reset_the_filter(){

}

function renderFilterResult(count){

  if (count>0){

    jQuery('.filter-count-result-it').html('Ho trovato <strong>'+count+'</strong> tessuti con i criteri selezionati.');
    jQuery('.filter-count-result-en').html('Founded <strong>'+count+'</strong> fabrics that satisfy the research.');

  }else{

    jQuery('.filter-count-result-it').html('Non ci sono tessuti con i criteri selezionati.');
    jQuery('.filter-count-result-en').html('There are no fabrics that satisfy the research.');

  }

  


}



function textileFilter(){ 

 
   
    var filters = [] ;

    /* ACQUISISCO I PARAMETRI */

    filters.underwear =   jQuery('.filter-set-applications #chkbox-underwear').is(":checked");
    filters.swimwear =    jQuery('.filter-set-applications #chkbox-swimwear').is(":checked");
    filters.sportswear =  jQuery('.filter-set-applications #chkbox-sportswear').is(":checked");
    filters.readytowear = jQuery('.filter-set-applications #chkbox-readytowear').is(":checked");

    filters.weightLow =   jQuery('.filter-set-weight #slider-range').slider("values",0);
    filters.weightHigh =  jQuery('.filter-set-weight #slider-range').slider("values",1);

    filters.textileName =  jQuery('.filter-set-name .to-select2').val();



    // FILTRI FEATURES
    /*filters.extra_comfort =   jQuery('.filter-set-features #chkbox-extra-comfort').is(":checked");
    filters.body_moisture_system =   jQuery('.filter-set-features #chkbox-body-moisture-system').is(":checked");
    filters.quick_drying =   jQuery('.filter-set-features #chkbox-quick-drying').is(":checked");
    filters.sun_block =   jQuery('.filter-set-features #chkbox-sun-block').is(":checked");
    filters.extra_fine =   jQuery('.filter-set-features #chkbox-extra-fine').is(":checked");
    filters.chlorine_resistance =   jQuery('.filter-set-features #chkbox-chlorine-resistance').is(":checked");
    filters.no_pilling =   jQuery('.filter-set-features #chkbox-no-pilling').is(":checked");
    filters.easy_care =   jQuery('.filter-set-features #chkbox-easy-care').is(":checked");
    filters.wrinkle_free =   jQuery('.filter-set-features #chkbox-wrinkle-free').is(":checked");
    */

   
   /* CONFRONTO OGNI TESSUTO CON I PARAMETRI*/

    var count = 0;

    jQuery('#ricerca-tessuti .tessuto').each(function(){
         //console.log(jQuery(this).attr('id'));

        
        if( textileIsHidden(jQuery(this),filters) ){

            textileHide(jQuery(this));
           /* jQuery(this).removeClass('textile-show');//fadeTo(200,0.2);*/
            //console.log('nascosto');
        }else{
             textileShow(jQuery(this));
            // jQuery(this).addClass('textile-show');//fadeTo(200,1);
             //console.log('visibile');
             count++;
        }
    });
    renderFilterResult(count);
}


/*
*
* Evidenzio i tessuti all'hover sul checkbox
*
*/

function textileFocusOver(event){ 

   
    switch(jQuery(event.target).attr('for')) {
    case 'chkbox-underwear':
        jQuery('*[data-underwear="true"]').addClass('textile-focus');
        break;
    case 'chkbox-swimwear':
         jQuery('*[data-swimwear="true"]').addClass('textile-focus');
        break;
    case 'chkbox-sportswear':
        jQuery('*[data-sportswear="true"]').addClass('textile-focus');
        break;
    case 'chkbox-readytowear':
        jQuery('*[data-readytowear="true"]').addClass('textile-focus');
        break;
} 

}
function textileFocusOut(event){ 
      jQuery('.textile-focus').removeClass('textile-focus');
     // console.log(event.target);
}


function texileInit(){

          // INIZIO applications
          jQuery( ".filtri .filter-set-applications input" ).checkboxradio({
              icon: false,
          });

          // INIZIO SLIDER PESO
          jQuery( "#slider-range" ).slider({
            range: true,
            min: 40,
            max: 380,
            values: [ 80, 340],
            slide: function( event, ui ) {           
              jQuery( "#weight" ).val(  ui.values[ 0 ] + " - " + ui.values[ 1 ] + " g/m2" );
            }
          });


          jQuery( "#weight" ).val(  jQuery( "#slider-range" ).slider( "values", 0 ) +
            " - " + jQuery( "#slider-range" ).slider( "values", 1 )+ " g/m2" );


          // INIZIO features
          jQuery( ".filtri .filter-set-features  input" ).checkboxradio({
              icon: false,
          });

         //INIZIO select by name
          jQuery('.to-select2').select2({
            placeholder: 'SEARCH...',
            allowClear: true        
          });

           // INIZIO RESET
          jQuery( ".filtri .filter-reset" ).click(function(event){

            event.preventDefault();
           

            jQuery( ".filtri .filter-set-applications input" ).removeAttr('checked');
            jQuery( ".filtri .filter-set-applications input" ).checkboxradio( "refresh" );

            jQuery('.filter-set-name .to-select2').val(null).trigger("change");

            jQuery('.filter-set-weight #slider-range').slider("values",[ 80, 340 ]);
             jQuery( "#weight" ).val(  jQuery( "#slider-range" ).slider( "values", 0 ) +
            " - " + jQuery( "#slider-range" ).slider( "values", 1 )+ " g/m2" );





           
            textileFilter();
          });

          // associo filtri

          jQuery("#slider-range").on("slidestop",textileFilter);
          
          jQuery('.to-select2').on('change',textileFilter);

          jQuery('.tocontrol').on('change',textileFilter);

          /*jQuery('.features-fieldset').on('change',textileFilter);*/

          // quando sopra una application evidenzio i tessuti selezionati
          //jQuery('.filter-set-applications .chkbox-application').hover(textileFocusOver,textileFocusOut);

}






